'use client';
import { TypeOurPeopleWithoutUnresolvableLinksResponse } from '@/features/contentful/_generated';
import Link from 'next/link';
import LinkedinIcon from '../../../public/images/linkedin-icon.svg';
import { useSettingsContext } from '@/contexts/SettingsContext';
import MainBodyToReact from '@/features/contentful/components/MainBodyToReact';
import { useContentfulInspectorMode } from '@contentful/live-preview/react';
import CustomImage from '@/components/CustomImage/CustomImage';

const LeaderDetailModal = ({
    leader,
}: {
    leader: TypeOurPeopleWithoutUnresolvableLinksResponse;
}) => {
    const inspectorProps = useContentfulInspectorMode({ entryId: leader.sys.id });
    const { name, picture, position, linkedin, mainBody } = leader.fields;

    const { getLabel } = useSettingsContext();
    const OUR_PEOPLE_LABEL = getLabel('label', 'ourPeople');

    const linkedinNavigateWithGTM = (e: React.MouseEvent<HTMLAnchorElement>) => {
        e.preventDefault();
        window.dataLayer &&
            window.dataLayer.push({
                event: 'linkedin_outbound_click',
                linkedin_profile: e.currentTarget.href,
            });
        window.open(e.currentTarget.href, e.currentTarget.target);
    };

    return (
        <div className="tw-flex tw-flex-col-reverse sm:tw-flex-row tw-justify-end  tw-bg-white sm:tw-pt-[30px] md:tw-pt-0">
            <div className=" sm:tw-w-[50%] tw-p-[13px] sm:tw-py-0  tw-min-h-[400px] tw-overflow-y-auto [@media(max-height:780px)_and_(min-width:576px)]:tw-h-[calc(100dvh_-_20dvh)] max-sm:overflow-y-auto max-sm:tw-max-h-[calc(100dvh_-_250px)]">
                <h2 className="lg:tw-text-[14px] tw-text-[14px] md:tw-text-[14px] tw-font-gotham-medium tw-text-pink1 tw-pb-[5px] ">
                    {OUR_PEOPLE_LABEL}
                </h2>
                <h3
                    className="tw-text-[32px] tw-font-gotham-bold tw-text-textBlue"
                    {...inspectorProps({
                        fieldId: 'name',
                    })}
                >
                    {name}
                </h3>
                <p
                    className="tw-text-[14px] tw-font-gotham-book tw-text-textBase tw-pb-[32px]"
                    {...inspectorProps({
                        fieldId: 'position',
                    })}
                >
                    {position}
                </p>
                {mainBody && (
                    <div
                        {...inspectorProps({
                            fieldId: 'mainBody',
                        })}
                    >
                        <MainBodyToReact
                            body={mainBody}
                            classes={{
                                p: 'tw-text-[12px] lg:tw-text-[14px] tw-leading-6 xl:tw-leading-7 tw-font-gotham-book tw-text-[#71757A] tw-pb-[32px]',
                            }}
                        />
                    </div>
                )}
                {linkedin && (
                    <Link href={linkedin} target="_blank" onClick={linkedinNavigateWithGTM}>
                        <LinkedinIcon
                            height={35}
                            width={35}
                            {...inspectorProps({
                                fieldId: 'linkedin',
                            })}
                        />
                    </Link>
                )}
            </div>
            <div className="tw-flex  sm:tw-flex-col tw-w-full sm:tw-w-[50%] tw-px-[13px]  tw-items-center tw-justify-center sm:tw-justify-start md:tw-justify-center lg:tw-justify-start tw-bg-[#dadad6] sm:tw-bg-white">
                <div
                    className="
                tw-w-[277px]
                sm:tw-w-full
                tw-overflow-hidden
                tw-h-[180px] 
                md:tw-h-[272px] 
                lg:tw-h-[453px]
                xl:tw-h-[500px]
                sm:tw-border-br-80"
                >
                    {picture?.fields.file?.url ? (
                        <CustomImage
                            src={`https:${picture.fields.file.url}?fm=webp`}
                            width={465}
                            height={453}
                            alt={picture.fields.title ?? name}
                            className="tw-w-full tw-h-full tw-object-cover"
                            {...inspectorProps({
                                fieldId: 'picture',
                            })}
                        />
                    ) : null}
                </div>
            </div>
        </div>
    );
};

export default LeaderDetailModal;
